import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../components/Loader';
import { useSettings } from '../context/SettingsContext';

const Services = () => {

    const [servbanner, setServbanner] = useState(null);
    const { renderHTML, services } = useSettings();
    const getServBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/ServicePageBanner`);
            setServbanner(res.data.data[0]);
        } catch (err) {
            console.error('Error fetching Banner Content:', err);
        }
    }

    useEffect(() => {
        getServBanner();
    }, [])

    if (servbanner === null || services === null) {
        return <Loader />
    }

    return (
        <>
            <section className="inner-banner" style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_IMAGES}${servbanner.image_2})` }}>
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration={1000}>
                            <div className="inner-banner-left">
                                <h1>{servbanner.title}</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${servbanner.image}`} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            {
                services.map((srv_itm, index) => {
                    return <section className="mobile-tyre-section" key={index}>
                        <div className="container-fluid">
                            <div className="row mobile-tyre-section-row">
                                <div className="col-md-6" data-aos="fade-right" data-aos-duration={1000}>
                                    <div className="mobile-tyre-left">
                                        <h2>{srv_itm.title}</h2>
                                        {renderHTML(srv_itm.details)}
                                        <Link to={`/service/${srv_itm.id}`} className="theme-btn mt-4">Read more<span><img src="images/arrow-right.png" alt="icon" /></span></Link>
                                    </div>
                                </div>
                                <div className="col-md-6" data-aos="fade-left" data-aos-duration={1000}>
                                    <div className="mobile-tyre-righ">
                                        <img src={`${process.env.REACT_APP_SITE_IMAGES}${srv_itm.photo}`} alt={srv_itm.title} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                })
            }
        </>
    )
}

export default Services